import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { actionCreators } from 'react/api/actions/chat';
import TicketActionsModals from 'react/containers/modals/Chat';
import ChatWindow from './Window';
import ChatService from '../../services/chat.service';

function ChatContainer({
  chatState,
  ticketHubIsOpen,
  getUnreadMessages,
  suspenseActionsIsOpen,
  miniDashboardIsOpen
}) {
  async function connectChatService() {
    Monet.Session.Chat = Monet.Session.Chat || {};
    Monet.Session.Chat.Service = new ChatService();

    await Monet.Session.Chat.Service.connect();
  }

  const chatWindows = useMemo(() => Object.keys(chatState.toJS())
    .filter((item) => item.startsWith('chatWindow_')),
  [chatState]);

  const hasContainersConflictings = useMemo(
    () => ticketHubIsOpen || (miniDashboardIsOpen && suspenseActionsIsOpen),
  [ticketHubIsOpen, suspenseActionsIsOpen, miniDashboardIsOpen]);

  useEffect(() => {
    connectChatService().then(() => {
      getUnreadMessages();
    });

    return () => {
      Monet.Session.Chat.Service.closeConnection();
    };
  }, [Monet.Session.User]);

  return (
    <>
      <div id="chatContainer">
        <div
          className={`chatWindows ${hasContainersConflictings && 'hasContainersConflictings'}`}
        >
          {chatWindows.map((item) => (
            <ChatWindow
              key={item}
              chatId={item}
            />
          ))}
        </div>
      </div>
      <TicketActionsModals />
    </>
  );
}

ChatContainer.propTypes = {
  chatState: PropTypes.object.isRequired,
  getUnreadMessages: PropTypes.func.isRequired,
  ticketHubIsOpen: PropTypes.bool.isRequired,
  suspenseActionsIsOpen: PropTypes.bool.isRequired,
  miniDashboardIsOpen: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ chat, ticketHub, footer }) => ({
  chatState: chat,
  ticketHubIsOpen: ticketHub.get('isOpen'),
  suspenseActionsIsOpen: footer.get('suspenseActionsIsOpen'),
  miniDashboardIsOpen: footer.get('miniDashboardIsOpen'),
});

const mapDispatchToProps = {
  getUnreadMessages: actionCreators.getUnreadMessages
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatContainer);
